import { render, staticRenderFns } from "./VideoRoomParticipantVideo.vue?vue&type=template&id=4bbda468&scoped=true&"
import script from "./VideoRoomParticipantVideo.vue?vue&type=script&lang=js&"
export * from "./VideoRoomParticipantVideo.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomParticipantVideo.vue?vue&type=style&index=0&id=4bbda468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbda468",
  null
  
)

export default component.exports